// extracted by mini-css-extract-plugin
module.exports = {"root":"_3LjyJ","btnContainer":"_15y7E","icon":"_30pwQ"};